export const service_package = {
  table: {
    field: {
      name: 'Название',
      subscription_fee: 'Абонентская плата',
      contact_count: 'Кол-во контактов',
      contact_method_count: 'Кол-во контакт-методов',
      ivr_count: 'Кол-во IVR',
      estimate: 'Оценка звонка',
      record: 'Запись звонков',
      disk_space_mb: 'Место на диске (МБ)',
      sip_account_with_caller_id_count: 'Кол-во SIP-аккаунтов для исходящих звонков'
    }
  },

  modal: {
    change: {
      content: 'Вы уверены что хотите подключить пакет услуг {name} для Виртуальной АТС?',
      buttons: {
        ok: 'Переключить'
      }
    },

    change_time: {
      title: 'Изменить пакет АТС сейчас?',
      content:
        'Вы можете изменить пакет услуг АТС сейчас или по завершении срока действия текущего пакета',
      buttons: {
        immediate: 'Сменить сейчас',
        deferred: 'Сменить {date}'
      }
    }
  },

  card: {
    cost: '{cost} в месяц',
    connect: 'Подключить',
    connected: 'Подключено',
    unlimited: 'Безлимитно'
  },

  limit: {
    record: 'Записи разговоров недоступны для вашего пакета услуг АТС',
    contacts: 'Создано максимальное количество контактов для вашего пакета услуг АТС',
    contact_methods:
      'Добавлено максимальное количество контакт методов, предусмотренное вашим пакетом услуг АТС',
    ivr: 'Создано максимальное количество IVR для вашего пакета услуг АТС'
  }
};
